import type {Document} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name newDocumentsDataService
 * @module portaro.components.kp-new-documents
 *
 *
 * @description
 * Data service for providing the newest documents
 */
export default class NewDocumentsDataService {
    public static serviceName = 'newDocumentsDataService';

    private readonly REQUESTS_ROUTE = '/newest-documents';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async query(): Promise<Document[]> {
        return this.ajaxService
            .createRequest(`${this.REQUESTS_ROUTE}`)
            .get();
    }
}
